var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity',{attrs:{"entity":"aspects","presentation":"blank","params":{ 'dh-aspect-id': _vm.aspect }}})
}
var staticRenderFns = []

export { render, staticRenderFns }